import { jsx as h } from "react/jsx-runtime";
import { SvgIcon as o } from "../SvgIcon.js";
const t = (m) => /* @__PURE__ */ h(o, { ...m, children: /* @__PURE__ */ h("path", { d: "M2.50713 12.943h6.67034v2.4958H2.50713V12.943Zm8.32687 0h6.6704v2.4958H10.834V12.943ZM2.50713 8.77953h6.67034v2.49587H2.50713V8.77953Zm8.32687 0h6.6704v2.49587H10.834V8.77953ZM2.50713 4.61609h6.67034v2.49585H2.50713V4.61609Zm8.32687 0h6.6704v2.49585H10.834V4.61609Z" }) });
export {
  t as Details
};
//# sourceMappingURL=Details.js.map
